import * as React from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'

import { buildOtherUrl } from '../../../../commons/utils'
import { FETCH_QUIZ_RESULT } from '../../../actions/questionActions'
import { CustomSpStore } from '../../../store'
import ImageAsset, { ImageAssetType } from '../../atoms/ImageAsset/ImageAsset'
import Spinner from '../../atoms/Spinner/Spinner'
import * as styles from './Complete.css'

interface CompletePropsFromStore {
  correctCount?: number
  resultTime?: number
  rank?: number
}

interface CompletePropsFromDispatch {
  fetchQuizResult: () => void
}

type CompleteProps = CompletePropsFromStore & CompletePropsFromDispatch

class Complete extends React.PureComponent<CompleteProps> {
  public componentDidMount() {
    this.props.fetchQuizResult()
  }

  public render() {
    const { rank, resultTime, correctCount } = this.props

    if (correctCount !== undefined && resultTime !== undefined && rank !== undefined) {
      return (
        <div className={styles.container}>
          <div className={styles.title}>
            <p className={styles.title}>
              あなたの順位
              <span className={styles.rank}>{rank}</span>位
            </p>
          </div>
          {rank < 11 ? <p className={styles.subtext}>おめでとうございます！</p> : null}
          <div className={styles.labelGroup}>
            <div className={styles.label}>
              <p className={styles.key}>正解数</p>
              <div className={styles.bar} />
              <p className={styles.value}>
                {correctCount}
                <span className={styles.unit}>問</span>
              </p>
            </div>
            <div className={styles.label}>
              <p className={styles.key}>回答時間</p>
              <div className={styles.bar} />
              <p className={styles.value}>
                {Math.floor(resultTime * 10) / 10}
                <span className={styles.unit}>秒</span>
              </p>
            </div>
          </div>
          <div className={styles.promotion}>
            <p className={styles.text}>リアルタイム参加型クイズを簡単に作ろう</p>
            <a className={styles.redButton} href={buildOtherUrl('?from=participant')}>
              無料で試してみる
            </a>
            <div className={styles.credit}>
              <ImageAsset type={ImageAssetType.CREDIT} />
            </div>
          </div>
        </div>
      )
    }

    return (
      <div className={styles.spinner}>
        <Spinner />
      </div>
    )
  }
}

const mapStateToProps = (state: CustomSpStore) => ({
  correctCount: state.questions.correctCount,
  rank: state.questions.rank,
  resultTime: state.questions.resultTime
})

const mapStateToDispatch = (dispatch: Dispatch) => ({
  fetchQuizResult: () => dispatch(FETCH_QUIZ_RESULT())
})

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(Complete)
